export const DOWNLOAD_RESULTS_PDF_FILE_SUCCESS = 'DOWNLOAD_RESULTS_PDF_FILE_SUCCESS';

export const downloadResultsPdfFileSuccess = () => ({
    type: DOWNLOAD_RESULTS_PDF_FILE_SUCCESS,
});
